// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  width: 780,
  height: 1280,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: undefined,
      stateByName: {}
    },
    {
      id: '7d94978e-da98-45e8-af39-4904c7f83773',
      type: 'Container',
      runtimeType: null,
      name: 'shopContainer',
      className: '',
      x: 390,
      y: 100,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '181b1e64-0618-4648-8a99-cd9b23c1d8a7',
      type: 'Container',
      runtimeType: null,
      name: 'shopInventorySlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7d94978e-da98-45e8-af39-4904c7f83773',
      data: undefined,
      stateByName: {}
    },
    {
      id: '29e310c4-81a9-4b46-a8b8-1cb4e9283a63',
      type: 'Container',
      runtimeType: null,
      name: 'spinnerSlot',
      className: '',
      x: 0,
      y: 378,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '7d94978e-da98-45e8-af39-4904c7f83773',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class ShopPopupLayout {
  static raw = raw;
  root: Container;
  shopContainer: Container;
  shopInventorySlot: Container;
  spinnerSlot: Container;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      shopContainer: typeof raw['list'][1];
      shopInventorySlot: typeof raw['list'][2];
      spinnerSlot: typeof raw['list'][3];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
